// example to replace the storage persistance of old redux state

import { createStore } from "@stencil/store";
import { HealthIntegrationKey } from "@sworkit/api";
import { PersistedStore, persistValues } from "./utils/persist-state";

export interface HealthStore extends PersistedStore<HealthStore> {
  availableIntegrations: HealthIntegrationKey[];
  /** persists in localstorage so that when a member comes back into the app, there's a record that they have turned this on and we then check permissions etc  */
  writeEnabledIntegrations: HealthIntegrationKey[];
  /** persists in localstorage so that when a member comes back into the app, there's a record that they have turned this on and we then check permissions etc  */
  readEnabledIntegrations: HealthIntegrationKey[];
}

const initialState: HealthStore = {
  availableIntegrations: [],
  writeEnabledIntegrations: [],
  readEnabledIntegrations: [],
  persistedKeys: ["writeEnabledIntegrations", "readEnabledIntegrations", "availableIntegrations"],
};

const { state, on } = createStore(initialState);
on("set", (key, newValue, oldValue) => {
  persistValues<HealthStore>(
    initialState.persistedKeys,
    key,
    newValue,
    oldValue,
  );
});

const healthIntegration = state;
export default healthIntegration;
